import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Html from 'slate-html-serializer';
import Reduce from 'lodash/reduce';
import BlockTypes from '../../../types/BlockTypes';
import StyleTypes from '../../../types/StyleTypes';
import { TEXT, MARK } from '../../../types/SlateTypes';
import tagNames from '../utils/tagNames';
import makeDefaultNodeDeserializers from '../utils/makeDefaultNodeDeserializers';
var DETECTION_REGEX = /id="docs-internal-guid/i;
var STYLES_TO_MARK = {
  'font-style:italic': StyleTypes.ITALIC,
  'text-decoration:underline': StyleTypes.UNDERLINE,
  'font-weight:700': StyleTypes.BOLD,
  'text-decoration:line-through': StyleTypes.STRIKETHROUGH
};

function stylesDeserializer(el, next) {
  // Sometime, Google encapsulate <br /> inside spans
  if (el.childNodes.length === 1 && el.childNodes[0].nodeName !== '#text') {
    return next(el.childNodes);
  }

  var eltStyles = el.style.cssText.replace(/\s/g, '');
  var marks = Reduce(STYLES_TO_MARK, function (acc, type, key) {
    return eltStyles.includes(key) ? [].concat(_toConsumableArray(acc), [{
      object: MARK,
      type: type
    }]) : acc;
  }, []);
  return {
    object: TEXT,
    text: el.innerText || el.textContent,
    marks: marks
  };
}

var TAGNAME_TO_BLOCK = _objectSpread({}, tagNames.TO_BLOCK, {
  DIV: function DIV(el, next) {
    return next(el.childNodes);
  },
  SPAN: stylesDeserializer
});

var TAGNAME_TO_ENTITY = _objectSpread({}, tagNames.TO_ENTITY, {
  BR: function BR(el, next) {
    if (el.parentElement.tagName === 'BODY') {
      return {
        object: TEXT,
        text: ''
      };
    }

    return tagNames.TO_ENTITY.BR(el, next);
  }
});

var TAGNAME_TO_MARK = _objectSpread({}, tagNames.TO_MARK, {
  B: function B(el, next) {
    return next(el.childNodes);
  }
});

var nodeDeserializers = makeDefaultNodeDeserializers({
  TAGNAME_TO_BLOCK: TAGNAME_TO_BLOCK,
  TAGNAME_TO_ENTITY: TAGNAME_TO_ENTITY,
  TAGNAME_TO_MARK: TAGNAME_TO_MARK
});
export default function makeGoogleDocsDeserializer(editor) {
  return {
    canDeserialize: function canDeserialize(_ref) {
      var type = _ref.type,
          html = _ref.html;
      return type === 'html' && DETECTION_REGEX.test(html);
    },
    deserialize: function deserialize(_ref2) {
      var rawHtml = _ref2.html;
      var html = rawHtml.replace(/(?:\r\n|\n\r)/g, '\n') // Remove all <b /> tags. Google use them with css to represent
      // everything. Useless information.
      .replace(/(<\/?b\s.*?>)/g, '');
      var deserializer = new Html({
        rules: [{
          deserialize: nodeDeserializers
        }],
        defaultBlock: BlockTypes.UNSTYLED
      });
      return deserializer.deserialize(html);
    }
  };
}